const ITEMS = ["Food Concept", "Menu", "Production", "Kitchen", "Manpower", "Workflow", "Economics", "Scale"];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-ink/10 bg-white py-5 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8 font-mono text-xs tracking-[0.4em] uppercase text-ink/35">
                {item}
                <span className="w-1.5 h-1.5 rounded-full bg-skope/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
